/**
 * Indicador de sincronização (ADR-003) + avisos: comandos recusados pelo servidor
 * e sessão expirada. Sempre visível no topo da casca.
 */
import { For, Show } from 'solid-js'
import { Button } from '@ui/components/Button'
import { estadoSync, sync } from '../nucleo/cliente'

const NOMES: Record<string, string> = {
  'clientes.create': 'Cadastro de cliente',
  'clientes.update': 'Alteração de cliente',
  'clientes.setAtivo': 'Ativar/inativar cliente',
}
const nomeOperacao = (area: string, metodo: string) => NOMES[`${area}.${metodo}`] ?? `${area}.${metodo}`

function quando(iso: string | null): string {
  if (!iso) return 'nunca'
  const d = new Date(iso)
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}

export function StatusSync() {
  const e = () => estadoSync()
  const rotulo = () => {
    const s = e()
    if (!s) return { texto: 'Conectando…', cor: 'bg-ink-placeholder' }
    if (s.sessaoExpirada) return { texto: 'Sessão expirada', cor: 'bg-warning' }
    if (s.sincronizando) return { texto: 'Sincronizando…', cor: 'bg-accent' }
    if (!s.online) return { texto: s.pendentes ? `Offline · ${s.pendentes} pendente(s)` : 'Offline', cor: 'bg-warning' }
    if (s.pendentes) return { texto: `${s.pendentes} pendente(s)`, cor: 'bg-accent' }
    return { texto: `Sincronizado · ${quando(s.ultimaSync)}`, cor: 'bg-success' }
  }
  return (
    <button
      type="button"
      onClick={() => void sync.agora()}
      title="Sincronizar agora"
      class="flex items-center gap-1.5 h-8 px-3 rounded-full border border-edge text-xs text-ink-muted hover:bg-hover"
    >
      <span class={`size-1.5 rounded-full ${rotulo().cor}`} />
      {rotulo().texto}
    </button>
  )
}

/** Faixa de avisos abaixo do topo: recusas (com motivo) e sessão expirada. */
export function AvisosSync(props: { aoEntrarDeNovo: () => void }) {
  const s = () => estadoSync()
  return (
    <>
      <Show when={s()?.sessaoExpirada}>
        <div class="flex items-center gap-3 px-4 py-2 border-b border-warning/40 bg-warning/10 text-sm">
          <span class="flex-1">Sua sessão no servidor expirou. Suas alterações estão guardadas neste computador; entre de novo para enviá-las.</span>
          <Button size="sm" variant="secondary" onClick={() => props.aoEntrarDeNovo()}>
            Entrar de novo
          </Button>
        </div>
      </Show>
      <Show when={(s()?.recusados.length ?? 0) > 0}>
        <div class="flex items-start gap-3 px-4 py-2 border-b border-failure/40 bg-failure/10 text-sm">
          <div class="flex-1 flex flex-col gap-0.5">
            <span class="font-medium">O servidor não aceitou {s()!.recusados.length} alteração(ões) feita(s) neste computador:</span>
            <For each={s()!.recusados}>
              {(r) => (
                <span class="text-ink-muted">
                  {nomeOperacao(r.area, r.metodo)}: {r.erro}
                </span>
              )}
            </For>
          </div>
          <Button size="sm" variant="secondary" onClick={() => void sync.dispensarRecusados()}>
            Entendi
          </Button>
        </div>
      </Show>
    </>
  )
}
